module.exports = __webpack_public_path__ + "static/media/IMG_1921.abfb22a7.jpg";